import arrayType from './array';

export default arrayType;
